import { useState, useEffect } from "react";
import Container from "../Componentes/Container";
import Cabecera from "../Componentes/Cabecera";
import InfoEstudiante from "../Componentes/InfoEstudiante";
import LineaRoja from "../Componentes/LineaRoja";
import Regularidad from "../Componentes/Regularidad";
import { useConstancia } from "../State/ConstanciaContext";
import { Stack, CircularProgress } from "@mui/material";
import ImgEstudiante from "../Componentes/ImgEstudiante";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useBody } from "../../Body/state/BodyContext";
import ErrorQR from "../Componentes/ErrorQR";
import { RUTA_API_CREDENCIAL } from "../../Contantes/Constantes";
import axios from "axios";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";

export default function Constancia() {
  const { data_alumno } = useConstancia();
  // @ts-ignore
  const { setMessage } = useBody();
  const [foto, setFoto] = useState("");
  const [condicion, setCondicion] = useState("");
  const [errorParam, setErrorParam] = useState(false);
  const [constancia, setConstancia] = useState(undefined);
  const [loadingConstancia, setLoadingConstancia] = useState(true);
  const desktop = useMediaQuery("(min-width: 1000px)");
  const axiosInstance = setupInterceptorsTo(axios.create());

  const extraerDatosConstancia = (data) => {
    const datosConstancia = {
      "Apellido y Nombre": data.apellido_nombre,
      "Nº Legajo": data.legajo,
      "Tipo de Documento": data.tipo_doc,
      "Número de Documento": data.nro_doc,
      Categoría: data.categoria,
    };
    return datosConstancia;
  };

  const verificarValidezQr = (fecha_generacion) => {
    const fechaActual = new Date();
    const fechaGeneracion = new Date(fecha_generacion);
    fechaGeneracion.setUTCHours(fechaGeneracion.getUTCHours() + 3);

    var diferencia = fechaActual.getTime() - fechaGeneracion.getTime();
    return diferencia <= 600000; // 600,000 milisegundos = 10 minutos
  };

  useEffect(() => {
    setLoadingConstancia(true);
    if (data_alumno) {
      fetch(`${RUTA_API_CREDENCIAL}/constancia/desencriptar?hash=${data_alumno}`)
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then(data => {
            if (verificarValidezQr(data.fecha_generacion)) {
              setConstancia(extraerDatosConstancia(data));
              setFoto(data.foto);
              setCondicion(data.regularidad_alumno);
              setLoadingConstancia(false);
            } else {
              setErrorParam(true);
              setLoadingConstancia(false);
            }
          })
          .catch(error => {
            setErrorParam(true);
            setMessage('Ocurrió un error al obtener los datos de la constancia');
          });
    }
  }, [data_alumno]);

  return (
    <Container>
      <Cabecera />
      {loadingConstancia ? (
        <Stack sx={{ justifyContent: "center", alignItems: "center", flex: 1 }}>
          <CircularProgress />
        </Stack>
      ) : (
        <>
          {errorParam ? (
            <ErrorQR error={"¡El QR ha vencido!"} descripcion={"Solicite que se genere uno nuevo e intente otra vez"}/>
          ) : (
            <>
              <ImgEstudiante foto={foto} />
              <Stack
                sx={{
                  flexDirection: "column",
                  ...(desktop && {
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "space-evenly",
                  }),
                }}
              >
                <InfoEstudiante data={constancia} />
                <Regularidad condicion={condicion} />
              </Stack>
              <LineaRoja />
            </>
          )}
        </>
      )}
    </Container>
  );
}
